import { render, staticRenderFns } from "./HowToScreen.vue?vue&type=template&id=5879ccc7&scoped=true&"
import script from "./HowToScreen.vue?vue&type=script&lang=js&"
export * from "./HowToScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5879ccc7",
  null
  
)

export default component.exports